module.exports = __webpack_public_path__ + "static/media/profileIcon.7f5f804c.svg";